module.exports = __webpack_public_path__ + "static/vegetar-vs-veganer-vs-pescetar-vs-fleksitar-d6138c3cb2ba918849446a74ea8e9a1d.png";